const scheduleIdleCallback: typeof window.requestIdleCallback =
  window.requestIdleCallback || ((callback: IdleRequestCallback) => window.setTimeout(callback, 0));

export default scheduleIdleCallback;
